import { Button, Drawer } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { IExportButton } from '../../../models/purchase-history';
import { ExportCSVForm } from '../export-csv/ExportCSVForm';

export const ExportButton = ({
  orderHistoryRequest,
  setAlertState,
  totalNumberOfOrders,
}: IExportButton) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        data-testid="export-button"
        variant="ghost"
        startIcon={Orders}
        onClick={() => handleOpen()}
      >
        Export
      </Button>
      <Drawer
        open={open}
        onClose={handleClose}
        position="right"
        style={{ zIndex: 2000000008 }}
      >
        <ExportCSVForm
          setAlertState={setAlertState}
          closeDrawer={handleClose}
          orderHistoryRequest={orderHistoryRequest}
          totalNumberOfOrders={totalNumberOfOrders}
        />
      </Drawer>
    </>
  );
};
